// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "orderCard_container-1TsG9";
var _4 = "orderCard_typeReview-1b4Tz";
var _5 = "commonItem_root-1ji_r";
var _6 = "paymentStatus_root-2ZPzj";
var _7 = "commonItem_payload-1HbEA";
var _8 = "paymentStatus_account-3fDQr";
var _9 = "orderStatus_transactions-20_Du";
var _a = "orderStatus_root-3Swms";
var _b = "orderStatus_typeReview-2Wny6";
var _c = "orderStatus_confirmed-3Qebu";
var _d = "orderBooking_root-2Alsm";
var _e = "orderBooking_typeReview-2uPLP";
var _f = "orderBooking_orderCode-3j-CD";
var _10 = "orderPassengers_control-UQCpP";
var _11 = "orderTickets_link-aHZk0";
var _12 = "type_account-3stEO";
var _13 = "preview-2sPPG";
var _14 = "orderCardControls_buttonCheckin-3zyXX";
var _15 = "orderChange__button-1rYOg";
var _16 = "orderPreview__root-7DP_k";
var _17 = "commonItem_review-3cbu7";
export { _1 as "__esModule", _2 as "mobile", _3 as "orderCard_container", _4 as "orderCard_typeReview", _5 as "commonItem_root", _6 as "paymentStatus_root", _7 as "commonItem_payload", _8 as "paymentStatus_account", _9 as "orderStatus_transactions", _a as "orderStatus_root", _b as "orderStatus_typeReview", _c as "orderStatus_confirmed", _d as "orderBooking_root", _e as "orderBooking_typeReview", _f as "orderBooking_orderCode", _10 as "orderPassengers_control", _11 as "orderTickets_link", _12 as "type_account", _13 as "preview", _14 as "orderCardControls_buttonCheckin", _15 as "orderChange__button", _16 as "orderPreview__root", _17 as "commonItem_review" }
export default { "__esModule": _1, "mobile": _2, "orderCard_container": _3, "orderCard_typeReview": _4, "commonItem_root": _5, "paymentStatus_root": _6, "commonItem_payload": _7, "paymentStatus_account": _8, "orderStatus_transactions": _9, "orderStatus_root": _a, "orderStatus_typeReview": _b, "orderStatus_confirmed": _c, "orderBooking_root": _d, "orderBooking_typeReview": _e, "orderBooking_orderCode": _f, "orderPassengers_control": _10, "orderTickets_link": _11, "type_account": _12, "preview": _13, "orderCardControls_buttonCheckin": _14, "orderChange__button": _15, "orderPreview__root": _16, "commonItem_review": _17 }
